import { useContext, useEffect } from 'react';
import SpinnerContext from '~/context/vdp/SpinnerContext';

function HeroData() {
  const { spinnerReady, setHasError } = useContext(SpinnerContext);

  const spinnerHasError = Boolean(spinnerReady.error);

  useEffect(() => {
    setHasError(spinnerHasError);
  }, [setHasError, spinnerHasError]);

  return null;
}

export default HeroData;
